import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { Label, Input } from "./styles";
import colors from "core/colors";

const UnstyledCheckbox = ({
    className,
    label,
    isChecked,
    onClick,
    onChange,
    isDisabled = false,
    inputValue,
    ariaLabel,
    otherCheckboxProps,
    isFlexBox = false,
    isCheckedBackground = colors.accent.lightMode.pansy
}) => {
    inputValue = inputValue || label;

    return (
        <Label isDisabled={isDisabled} className={className}>
            <Input
                isDisabled={isDisabled}
                isChecked={isChecked}
                type="checkbox"
                value={inputValue}
                checked={isChecked}
                aria-disabled={isDisabled}
                aria-label={ariaLabel}
                isFlexBox={isFlexBox}
                onClick={e => {
                    if (isDisabled) return;
                    onClick(!isChecked, e);
                }}
                onChange={e => {
                    if (isDisabled) return;
                    if (onChange) onChange(e);
                }}
                isCheckedBackground={isCheckedBackground}
                {...otherCheckboxProps}
            />
            <span
                data-testid={
                    isChecked
                        ? "core-checkbox-checked"
                        : "core-checkbox-unchecked"
                }
            >
                <span>{label}</span>
            </span>
        </Label>
    );
};

const Checkbox = styled(UnstyledCheckbox)``;

Checkbox.propTypes = {
    label: PropTypes.any,
    isChecked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    isFlexBox: PropTypes.bool,
    inputValue: PropTypes.string,
    isCheckedBackground: PropTypes.string,
    ariaLabel: PropTypes.string
};

export default Checkbox;
